import $ from 'jquery';
import _ from 'lodash';
import { getState, getStatePure, modifyState } from '~src/state';
import editorConfig from '~config/editorConfig';

export const displaySidebarAnimations = () => {
  const pages = getStatePure('pages');
  const currentPageIndex = getStatePure('currentPageIndex');

  modifyState('soundtrackId', _.get(pages[currentPageIndex], 'soundtrackId'));

  const animations =
    typeof pages[currentPageIndex]?.animations === 'string' &&
    pages[currentPageIndex]?.animations
      ? JSON.parse(pages[currentPageIndex]?.animations)
      : pages[currentPageIndex]?.animations
      ? pages[currentPageIndex]?.animations
      : [];

  let html = '';

  if (animations.length > 0) {
    $('#giotto-video-preview, #btn-sidebar-animations').removeClass('d-none');
  } else {
    html = '<div>Non ci sono animazioni</div>';
    $('#giotto-video-preview, #btn-sidebar-animations').addClass('d-none');
  }

  let index = 0;
  for (const animation of animations) {
    html += `
      <div class="d-flex flex-column bd-highlight mb-3 rounded border border-white p-2">
      <div class="row p-2">
        <div class="col p-2">
          <div class="text-left bd-highlight">${index + 1} - ${
      animation.title
    }</div>
        </div>
        <div class="col2 p-2">
          <button class="btn data-animation-delete btn-danger-light" data-animation-delete data-animation-index="${index}">Elimina</button>
        </div>
      </div>
      <div class="row p-2">
          <div class="p-2 text-left bd-highlight">Tempo</div>
          <div class="col p-2">
            <input
              type="range"
              data-animation-duration-control
              data-animation-index="${index}"
              min="0.1"
              max="10"
              value="${animation.toProps.duration}"
              step="0.1"
              class="slider"
            />
          </div>
          <div class="col-3 p-2">
            <input
              type="number"
              value="${animation.toProps.duration}"
              class="form-control-editor"
              readonly
            />
          </div>
        </div>`;
    if (animation.toProps) {
      html += `
      <div class="row p-2">
        <div class="p-2 text-left bd-highlight">Velocità</div>
        <div class="col p-2">
          <select data-animation-effect data-animation-index="${index}"></select>
        </div>
      </div>
      `;
    }
    html += `

      <div class="row p-2">
        <div class="p-2 text-left bd-highlight">Elementi</div>
          <div class="p-2 text-left bd-highlight" data-animation-switch data-animation-index="${index}">${animation.objects.length}</div>
        </div>
      </div>
      `;
    index = index + 1;
  }

  if (animations.length > 0) {
    $('#animationsCount').html(
      `<span class="badge badge-pill badge-light">${animations.length}</span>`
    );
  } else {
    $('#animationsCount').empty();
  }

  $('#editor-sidebar-animations').html(html);
  $('body').off('change', '[data-animation-effect]');

  $('[data-animation-effect]').select2({
    data: editorConfig.video.easeEffects,
    tags: false,
    allowClear: true,
    width: '100%',
    theme: 'bootstrap4',
    placeholder: 'Seleziona una velocità',
  });

  $('[data-animation-effect]').each(function () {
    const index = $(this).data('animation-index');
    const pages = getStatePure('pages');
    const currentPageIndex = getState('currentPageIndex');
    const ease = _.get(
      pages,
      `[${currentPageIndex}].animations[${index}].toProps.ease`,
      'Linear'
    );
    $(this).val(ease).trigger('change');
  });

  $('body').on('change', '[data-animation-effect]', async (event) => {
    const ease = $(event.currentTarget).val();
    const index = $(event.currentTarget).data('animation-index');
    const pages = getStatePure('pages');
    const currentPageIndex = getState('currentPageIndex');
    pages[currentPageIndex].animations[index].toProps.ease = ease;
    await modifyState('pages', pages);
  });
};
